import React from 'react';

export default function ReportHeader({ activeTab, setActiveTab }) {
  return (
    <div className="flex border-b border-slate-200 mb-6 bg-white rounded-xl p-1.5 shadow-sm print-hide">
      <button
        onClick={() => setActiveTab('daily')}
        className={`flex-1 py-3 text-xs font-black rounded-lg transition-all flex items-center justify-center gap-1.5 ${
          activeTab === 'daily' ? 'bg-indigo-600 text-white shadow-md' : 'text-slate-500 hover:bg-slate-50'
        }`}
      >
        <span className="material-icons-round text-sm">today</span>일일
      </button>
      <button
        onClick={() => setActiveTab('weekly')}
        className={`flex-1 py-3 text-xs font-black rounded-lg transition-all flex items-center justify-center gap-1.5 ${
          activeTab === 'weekly' ? 'bg-indigo-600 text-white shadow-md' : 'text-slate-500 hover:bg-slate-50'
        }`}
      >
        <span className="material-icons-round text-sm">view_week</span>주간
      </button>
      <button
        onClick={() => setActiveTab('monthly')}
        className={`flex-1 py-3 text-xs font-black rounded-lg transition-all flex items-center justify-center gap-1.5 ${
          activeTab === 'monthly' ? 'bg-indigo-600 text-white shadow-md' : 'text-slate-500 hover:bg-slate-50'
        }`}
      >
        <span className="material-icons-round text-sm">calendar_month</span>월별
      </button>
    </div>
  );
}